export class DmsElementMoveResource {
  idElements: number[] = [];
  idDestinationFolder: number;
  fiscalYear: number;
  fiscalYearId: number;
}
